module.exports = __webpack_public_path__ + "static/xpExpertBG-b2a7780156fc4cbdfb15b1f0b4f512f2.jpg";